module.exports = __webpack_public_path__ + "static/media/03-10.1bc55588.png";